import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty, concat } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from 'jquery';

import plainify from '../../util/remove_html_markup';

function Tree({ items: goals, linkPrefix, forwardedRef={}, className='nav-menu-visible'  }) {
  const toggleCollapse = ({ currentTarget }) => {
    $(currentTarget)
      .toggleClass('env-collapser-legacy--off')
      .closest('.first-level-title')
      .next('.second-level-content')
      .slideToggle(_, () => {
        if ($(currentTarget).attr('aria-expanded') == 'false') {
          $(currentTarget).attr('aria-expanded', 'true');
        } else {
          $(currentTarget).attr('aria-expanded', 'false');
        }
      });
  };

  return (
    <nav className="env-nav" ref={forwardedRef}>
      <ul className={`nav-menu ${className}`}>
        {goals.reduce(function builder(collection, { id: to, title, items = [], measures = [], isMeasure }) {
          return concat(collection, [
            <li key={['tree', 'item', to].join('-')}>
              {isEmpty(measures) && isEmpty(items) ? (
                <Link to={`${linkPrefix}/${to}`} className="nav-menu-link">
                  {isMeasure ? <FontAwesomeIcon icon={['fal', 'chart-bar']} /> : ''}
                  <span>{plainify(title)}</span>
                </Link>
              ) : (
                <div className="dropdown-content">
                  <div className="first-level-title">
                    <Link to={`${linkPrefix}/${to}`} className="nav-menu-link">
                      {isMeasure ? <FontAwesomeIcon icon={['fal', 'chart-bar']} /> : ''}
                      <span>{plainify(title)}</span>
                    </Link>
                    <div className="nav-button-collapser-wrapper">
                      <button
                        className="env-collapser-legacy env-collapser-legacy--off"
                        onClick={toggleCollapse}
                        type="button"
                        aria-expanded={false}
                        aria-label="collapse"
                      >
                        <FontAwesomeIcon icon={['fal', 'chevron-down']} />
                      </button>
                    </div>
                  </div>
                  <ul className="second-level-content env-hide">
                    {measures.map((item) => builder([], item))}
                    {items.map((item) => builder([], item))}
                  </ul>
                </div>
              )}
            </li>,
          ]);
        }, [])}
      </ul>
    </nav>
  );
}

Tree.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  linkPrefix: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  className: PropTypes.string,
  forwardedRef: PropTypes.shape({}),
};

export default forwardRef((props, ref) => <Tree {...props} forwardedRef={ref} />);
